import { v4 as uuidv4 } from 'uuid';
import { IAttribute } from '../standard/AttributeModel';

export interface IEntity {
  uuid: string;
  readonly filesApiId: number | undefined;
  attributes: Array<IAttribute>;
  toJSON: () => object;
  getUUID: () => string;
}

abstract class Entity implements IEntity {
  uuid: string;

  readonly filesApiId: number | undefined;

  attributes: IAttribute[];

  constructor(attributes: Array<IAttribute> = []) {
    this.uuid = uuidv4();
    this.attributes = attributes;
  }

  getUUID(): string {
    return this.uuid;
  }

  setUUID(uuid: string) {
    this.uuid = uuid;
  }

  getFilesApiId(): number | undefined {
    return this.filesApiId;
  }

  getAttributes(): Array<IAttribute> {
    return this.attributes;
  }

  setAttributes(attributes: Array<IAttribute>) {
    this.attributes = attributes;
  }

  toJSON() {
    return {
      uuid: this.uuid,
      filesAPIId: this.filesApiId,
      attributes: this.attributes.length !== 0 ? this.attributes.map((a) => a.toJSON?.() ?? a) : undefined,
    };
  }

  static fromJSON(json: any): Entity {
    throw new Error('fromJSON must be implemented');
  }
}

export default Entity;
